
import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import stores from '../../stores';
import RecorderModule from '../../stores/modules/Recorders';

@Component({
  components: {},
})

export default class DeleteRecorder extends Vue {
  @Prop()
    module!: RecorderModule;
  /**
   * Fired when this module is created
   */
  created() {
    this.delete();
  }

  delete() {
    return this.module.deleteRecord(Number(this.$route.params.id))
      .then(() => {
        this.$router.push({name: `recorders`, params: {moduleId: String(this.module.id)}});
      })
      .catch((reason) => {
        console.error('Could not delete', reason);
      });
  }
}
